import React from "react";
//#region types
import { QuickActionButtonProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import SimpleTooltip from "../tooltips/tooltip";
import useMenuButtonClick from "./useMenuButtonClick";
import Icon from "../icon";
import StyledButton from "./styledButton";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const QuickActionButton: React.FC<QuickActionButtonProps> = (props) => {
  const onMenuItemClick = useMenuButtonClick();

  const handleButtonClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.persist();
    onMenuItemClick({ ...props }, props.disbaleSuccessMessage ?? false, event);
  };

  return !props.hidden ? (
    <SimpleTooltip text={LocalizationHelperInstance.getFormattedMessage(props.description)}>
      <Grid item className={cssExports.quickActionButtonGridItem}>
        <StyledButton
          className={cssExports.quickAction}
          onClick={handleButtonClick}
          displayType={props.highlightType}
          secondary={props.secondary}
        >
          <Icon icon={props.icon} />
        </StyledButton>
      </Grid>
    </SimpleTooltip>
  ) : (
    <></>
  );
};

export default QuickActionButton;
